const flavorName = process.env.VUE_APP_FLAVOR || 'domestic'
const isOverseas = flavorName === 'overseas'

const defaultLocale = process.env.VUE_APP_DEFAULT_LOCALE || (isOverseas ? 'en' : 'zh')
const defaultTimeZoneId = process.env.VUE_APP_DEFAULT_TIMEZONE || (isOverseas ? 'UTC' : 'Asia/Shanghai')
const brandTitle = process.env.VUE_APP_BRAND_TITLE || ''
const supportedLocales = ['zh', 'en']

/**
 * 底图缺省只跟区域 flavor 走，不跟 API 域名走：
 * - domestic（serve/build:domestic* / 默认 production→utc 测试）：天地图 tdt
 * - overseas（serve/build:overseas*）：谷歌 google
 * 可用 VUE_APP_DEFAULT_MAP_TYPE 覆盖（仅允许 tdt|google）。
 */
const rawDefaultMapType = process.env.VUE_APP_DEFAULT_MAP_TYPE || (isOverseas ? 'google' : 'tdt')
const defaultMapType = (rawDefaultMapType === 'tdt' || rawDefaultMapType === 'google')
  ? rawDefaultMapType
  : (isOverseas ? 'google' : 'tdt')

/**
 * mapchange 编码 A：'1'=google，'2'=国内底图（天地图或百度，视页面而定）。
 * 用于：数据总览 rlMapCompents；骑行/轨迹/对账等仍保留百度的页。
 * 海外缺省 google；国内缺省 '2'（不删百度，有百度的页即默认百度）。
 */
const defaultMapChange = defaultMapType === 'google' ? '1' : '2'

/**
 * mapchange 编码 B：'1'=tdt，'2'=google（与编码 A 相反）。
 * 用于：可视化报告、故障详情 mapComPonents 等天地图/谷歌页。
 * 海外缺省 google('2')；国内缺省 tdt('1')。
 */
const defaultMapChangeReport = defaultMapType === 'google' ? '2' : '1'

function resolveStoredLocale (stored) {
  if (stored === 'zh' || stored === 'en') return stored
  return defaultLocale
}

function getStoredLocale () {
  if (typeof localStorage === 'undefined') {
    return defaultLocale
  }
  const stored = localStorage.getItem('lang')
  const resolved = resolveStoredLocale(stored)
  if (stored != null && stored !== '' && stored !== resolved) {
    localStorage.setItem('lang', resolved)
  }
  return resolved
}

module.exports = {
  isOverseas,
  defaultLocale,
  defaultTimeZoneId,
  defaultMapType,
  defaultMapChange,
  defaultMapChangeReport,
  brandTitle,
  supportedLocales,
  resolveStoredLocale,
  getStoredLocale
}
